import { ChevronDown } from "lucide-react";
import EmergencyTrigger from "../../components/EmergencyTrigger";
import MapView from "../../components/MapView";
import AlertFeed from "../../components/AlertFeed";
import StatsPanel from "../../components/StatsPanel";
import ProximitySettings from "../../components/ProximitySettings";
import DrivingModeToggle from "../../components/DrivingModeToggle";
import SafeRoutePanel from "../../components/SafeRoutePanel";
import LocationStatus from "./LocationStatus";

export default function MobileLayout({
  user,
  isAdmin,
  alerts,
  userLocation,
  stats,
  proximityRadius,
  updateProximity,
  setManualLocation,
  retryGPS,
  wsConnected,
  driving,
  recommendedRoute,
  setRecommendedRoute,
  trackingSessions,
  focusLocation,
  focusAlertId,
  onMarkerFocus,
  onTrigger,
  onResolve,
  onAssign,
  onDelete,
  onVote,
  onAlertFocus,
  mobilePanel,
  setMobilePanel,
}) {
  return (
    <div className="lg:hidden flex flex-col">
      {/* Emergency triggers — horizontal row */}
      <div className="bg-white border-b border-gray-200 px-3 py-3">
        <EmergencyTrigger onTrigger={onTrigger} mobile />
        <div className="mt-2 flex justify-end" data-testid="driving-mode-mobile">
          <DrivingModeToggle
            enabled={driving.enabled}
            onToggle={driving.toggle}
            trackedSince={driving.trackedSince}
            currentSpeedKph={driving.currentSpeedKph}
          />
        </div>
        {driving.enabled && (
          <div className="mt-3" data-testid="safe-route-mobile-slot">
            <SafeRoutePanel
              userLocation={userLocation}
              onRecommendedRoute={setRecommendedRoute}
            />
          </div>
        )}
      </div>

      {/* Map */}
      <div className="border-y border-gray-900 h-[45vh]">
        <MapView
          alerts={alerts}
          userLocation={userLocation}
          proximityRadius={proximityRadius}
          onLocationSet={setManualLocation}
          focusLocation={focusLocation}
          focusAlertId={focusAlertId}
          onMarkerFocus={onMarkerFocus}
          trackingSessions={trackingSessions}
          recommendedRoute={recommendedRoute}
        />
      </div>

      {/* Expandable panel: Stats + Proximity */}
      <button
        onClick={() => setMobilePanel(!mobilePanel)}
        className="bg-white border-b border-gray-200 px-4 py-2.5 flex items-center justify-between w-full"
        data-testid="mobile-panel-toggle"
      >
        <div className="flex items-center gap-3">
          {stats && (
            <span className="text-xs font-bold text-gray-700 font-body">
              {stats.active} active &middot; {stats.total} total
            </span>
          )}
          <span className="text-xs text-gray-500 font-body">&middot; Custom proximity</span>
        </div>
        <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform duration-150 ${mobilePanel ? "rotate-180" : ""}`} />
      </button>

      {mobilePanel && (
        <div className="bg-white border-b border-gray-200 px-4 py-3 grid grid-cols-2 gap-4">
          <div>
            <StatsPanel stats={stats} compact />
          </div>
          <div>
            <ProximitySettings radius={proximityRadius} onUpdate={updateProximity} />
            <LocationStatus location={userLocation} onRetry={retryGPS} wsConnected={wsConnected} />
          </div>
        </div>
      )}

      {/* Alert feed */}
      <div className="bg-white flex-1">
        <AlertFeed
          alerts={alerts}
          onResolve={onResolve}
          onAssign={isAdmin ? onAssign : null}
          onDelete={isAdmin ? onDelete : null}
          onVote={onVote}
          onFocus={onAlertFocus}
          focusAlertId={focusAlertId}
          user={user}
        />
      </div>
    </div>
  );
}
